// Utility functions for category labels (all types use stored label_fr / label_en or label)

import type { Category } from '../types';

/** Get translated label for a category. Uses label_fr / label_en; fallback to label if still present (legacy). */
export const getTranslatedCategoryLabel = (
  category: { id: number; label?: string | null; label_fr?: string | null; label_en?: string | null },
  _t: (key: string) => string,
  language: 'fr' | 'en' = 'fr'
): string => {
  const fr = category.label_fr ?? category.label ?? '';
  const en = category.label_en ?? category.label ?? '';
  return language === 'fr' ? (fr || en) : (en || fr);
};

/** Returns true if the category represents an email contact (for mailto vs copy). */
export const isEmailCategory = (category: Category | null): boolean => {
  if (!category) return false;
  const norm = (s: string | null | undefined) => s?.toLowerCase().trim() ?? '';
  const vals = [norm(category.label_fr), norm(category.label_en), norm(category.label)];
  return vals.some(v => v === 'email' || v === 'e-mail' || v === 'courriel');
};
